import DialogConfirmation from './DialogConfirmation';

export default DialogConfirmation;
